import { render } from "./CardBody.vue?vue&type=template&id=3adf2ef8"
import script from "./CardBody.vue?vue&type=script&lang=ts"
export * from "./CardBody.vue?vue&type=script&lang=ts"

import "./CardBody.vue?vue&type=style&index=0&id=3adf2ef8&lang=stylus"
script.render = render

export default script